/* Imports */
import { API_HELPER } from "@/helpers/api.js";
import { authHeader } from "@/helpers/auth-header.js";

/* Exports */
// API services that can be invoked on the modules
export const VOTEMOVEMENTS_SERVICE = { getVoteMovementsForUser };

/* Consts*/
// Root service to build API url
const API_ROOT_SERVICE = "VoteMovements";

/* Services */
//Service to get voteMovements
function getVoteMovementsForUser(id)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "user", id]);

    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}